import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2843c4f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = { key: 0 }



interface IProps {
  disabled?: boolean
  text?: string
}
interface IEmits {
  (e: 'click', evt?: MouseEvent): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    disabled: { type: Boolean },
    text: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click', evt?: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  disabled?: boolean
  text?: string
}




const onClick = (evt: MouseEvent) => {
  const { disabled = false } = props
  if (disabled) return
  emit('click', evt)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.disabled,
    class: _normalizeClass(['button', { 'disabled': !!__props.disabled }]),
    onClick: onClick
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (!!__props.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})